import {gql} from '@apollo/client';
import {ApptProps} from 'components/ApptDetails2';

// Interface representing returned data from API
export interface ApiAppt {
	id: string

	start: {
		date: string
		time: string
	}

	product: {
		id: string
		shortName: string
	}

	location: {
		details: {
			name: string
			address: {
				addr1: string
				addr2: string
			}
		}
		regions: {
			primary: string
		}
	}
}

// Class that wraps data to simplify access
export class ObjAppt {
	private _appt?: ApiAppt;

	constructor(appt?: ApiAppt) {
		this._appt = appt;
	}

	props = (): ApptProps | undefined => {
		if (!this._appt) {
			return;
		}

		const ax = this._appt;
		const loc = ax.location.details;
		const reg = ax.location.regions;

		return {
			id: ax.id,
			datetime: `${ax.start.date} ${ax.start.time}`,
			product: ax.product.shortName,
			productID: ax.product.id,
			location: loc.name,
			region: reg.primary,
			address: `${loc.address.addr1}, ${loc.address.addr2}`,
		};
	}
}

// Fragment to enable query composability
export const API_APPT = gql`
fragment ApiAppt on ApptDetails {
	id

	start {
		date: time(fmt: "Mon, Jan 02")
		time: time(fmt: "03:04 PM MST")
	}

	product {
		id
		shortName
	}

	location {
		details {
			name
			address {
				addr1
				addr2
			}
		}
		regions {
			primary
		}
	}
}`;
